<template>
    <main class="fap-page">
        <!-- Header -->
        <ThemeHeader />

        <div id="shopify-section-faq" class="shopify-section">
            <FaqAccordion />
        </div>

        <!-- Footer -->
        <div id="shopify-section-footer" class="shopify-section">
            <ThemeFooter />

            <!-- Footer Sale Box -->
            <FooterSaleBox />
        </div>
    </main>
</template>

<script>

    import ThemeHeader from "../components/common/ThemeHeader";
    import FaqAccordion from "../components/sections/FaqAccordion";
    import ThemeFooter from "../components/common/ThemeFooter";
    import FooterSaleBox from "../components/common/FooterSaleBox";
    export default {
        name: "Faq",
        components: {
            FooterSaleBox,
            ThemeFooter,
            FaqAccordion,
            ThemeHeader
        }
    }
</script>

<style scoped>

</style>